export default "__VITE_ASSET__BPlBqDpu__"